import React, { useState } from "react";
import { FormControlLabel, Switch } from "@mui/material";
import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_UploadDocument from "../../components/BSL_Upload/BSL_UploadDocument";
import { deepCopy } from "../../components/Common";
import Message from "../../components/Message";

const PremiumFeatures = ({ business, updateBusiness }) => {
    const [showMessage, setShowMessage] = useState(null);
    const [features, setFeatures] = useState(deepCopy(business.PremiumFeatures));

    const handleToggle = (event) => {
        const { name, checked } = event.target;

        const updatedFeatures = {
            ...features,
            [name]: checked,
        };

        setFeatures(updatedFeatures);
        updateBusiness({
            ...business,
            PremiumFeatures: updatedFeatures,
        });
    };

    const handleLogoUploadSuccess = (target) => (message) => {
        const updatedBusiness = {
            ...business,
            [target]: message.filename,
        };
        updateBusiness(updatedBusiness);
        setShowMessage(message);
    };

    const handleLogoClear = (target) => () => {
        const updatedBusiness = {
            ...business,
            [target]: null,
        };
        updateBusiness(updatedBusiness);
    };

    return (
        <React.Fragment>
            <BSL_Common.SectionRow style={{ paddingLeft: "10px" }}>
                <FormControlLabel
                    control={
                        <Switch
                            name="BrandedARViewer"
                            checked={features?.BrandedARViewer || false}
                            onChange={handleToggle}
                        />
                    }
                    label="Branded AR Viewer"
                />
            </BSL_Common.SectionRow>

            {features?.BrandedARViewer && (
                <BSL_Common.SectionRow>
                    <BSL_UploadDocument
                        buttonText="IMPORT LOGO..."
                        backgroundText="UPLOAD A LOGO FOR AR VIEWER"
                        onSuccess={handleLogoUploadSuccess("ARViewLogo")}
                        onError={setShowMessage}
                        onClear={handleLogoClear("ARViewLogo")}
                        documentFolder={`BUS_${business.Code}`}
                        documentSaveFilename=""
                        documentFilename={business?.ARViewLogo || "arlogo"}
                        documentType="arlogo"
                        sizeLimitMB={1}
                    />
                </BSL_Common.SectionRow>
            )}

            <BSL_Common.SectionRow style={{ paddingLeft: "10px" }}>
                <FormControlLabel
                    control={
                        <Switch
                            name="Branded3DModel"
                            checked={features?.Branded3DModel || false}
                            onChange={handleToggle}
                        />
                    }
                    label="Branded 3D Model"
                />
            </BSL_Common.SectionRow>

            {features?.Branded3DModel && (
                <BSL_Common.SectionRow>
                    <BSL_UploadDocument
                        buttonText="IMPORT LOGO..."
                        backgroundText="UPLOAD A LOGO FOR 3D MODEL"
                        onSuccess={handleLogoUploadSuccess("ThreeDModelLogo")}
                        onError={setShowMessage}
                        onClear={handleLogoClear("ThreeDModelLogo")}
                        documentFolder={`BUS_${business.Code}`}
                        documentSaveFilename=""
                        documentFilename={business?.ThreeDModelLogo || "3dlogo"}
                        documentType="3dlogo"
                        sizeLimitMB={1}
                    />
                </BSL_Common.SectionRow>
            )}

            <Message
                open={Boolean(showMessage)}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </React.Fragment>
    );
};

export default PremiumFeatures;
